import DOMPurify from 'dompurify';
import { lazy, memo, useMemo } from 'react';

import styles from './marketing-disclaimer.module.scss';

const InfoBlock = lazy(() => import('core/generic/elements/info-block'));

type MarketingDisclaimerProps = {
	/** Copy from the API, using `[label]` to mark the privacy-policy link. */
	message?: string;
	privacyPolicyUrl?: string;
};

const LINK_PLACEHOLDER = /\[([^\]]+)\]/g;

/**
 * Renders the channel disclaimer, turning `[label]` markers into links to the
 * privacy policy. The result is sanitised because the copy is API-supplied.
 */
const MarketingDisclaimerInner = ({
	message,
	privacyPolicyUrl,
}: MarketingDisclaimerProps) => {
	const html = useMemo(() => {
		if (!message) return '';

		const withLinks = message.replace(
			LINK_PLACEHOLDER,
			`<a href='${privacyPolicyUrl || ''}'>$1</a>`
		);

		return DOMPurify.sanitize(withLinks);
	}, [message, privacyPolicyUrl]);

	if (!html) return null;

	return (
		<div className={styles['info-block-alert']}>
			<InfoBlock variant="info" display="stacked">
				<span className="body-small">
					<div
						className={styles.disclaimer}
						dangerouslySetInnerHTML={{ __html: html }}
					/>
				</span>
			</InfoBlock>
		</div>
	);
};

export const MarketingDisclaimer = memo(MarketingDisclaimerInner);

export default MarketingDisclaimer;
